var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _path20, _path21, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 184,
    viewBox: "0 0 200 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7632_7878)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9395 121.787L85.6777 142.107L86.657 144.066L88.6156 143.576L100.612 122.032L96.9395 121.787Z",
    fill: "#C5BEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1888 153.145C88.1634 153.145 90.5749 150.734 90.5749 147.759C90.5749 144.784 88.1634 142.373 85.1888 142.373C82.2142 142.373 79.8027 144.784 79.8027 147.759C79.8027 150.734 82.2142 153.145 85.1888 153.145Z",
    fill: "#6041B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7632_7878",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 142,
    width: 12,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1888 153.145C88.1634 153.145 90.5749 150.734 90.5749 147.759C90.5749 144.784 88.1634 142.373 85.1888 142.373C82.2142 142.373 79.8027 144.784 79.8027 147.759C79.8027 150.734 82.2142 153.145 85.1888 153.145Z",
    fill: "#6041B0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7632_7878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1888 154.145C81.1634 154.145 83.5749 151.734 83.5749 148.759C83.5749 145.784 81.1634 143.373 78.1888 143.373C75.2142 143.373 72.8027 145.784 72.8027 148.759C72.8027 151.734 75.2142 154.145 78.1888 154.145Z",
    fill: "#8067C0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.075 121.787L137.336 142.107L136.357 144.066L134.399 143.576L122.402 122.032L126.075 121.787Z",
    fill: "#C5BEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 152.145C135.214 152.145 132.802 149.734 132.802 146.759C132.802 143.784 135.214 141.373 138.188 141.373C141.163 141.373 143.574 143.784 143.574 146.759C143.574 149.734 141.163 152.145 138.188 152.145Z",
    fill: "#6041B0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7632_7878",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 141,
    width: 12,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 152.145C135.214 152.145 132.802 149.734 132.802 146.759C132.802 143.784 135.214 141.373 138.188 141.373C141.163 141.373 143.574 143.784 143.574 146.759C143.574 149.734 141.163 152.145 138.188 152.145Z",
    fill: "#6041B0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7632_7878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.188 153.145C142.214 153.145 139.802 150.734 139.802 147.759C139.802 144.784 142.214 142.373 145.188 142.373C148.163 142.373 150.574 144.784 150.574 147.759C150.574 150.734 148.163 153.145 145.188 153.145Z",
    fill: "#8067C0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113 122H110V144H113V122Z",
    fill: "#C5BEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6855 48.3408H161.328V118.36C161.328 119.334 160.941 120.268 160.252 120.956C159.563 121.645 158.629 122.032 157.655 122.032H65.3579C64.3839 122.032 63.4498 121.645 62.7611 120.956C62.0724 120.268 61.6855 119.334 61.6855 118.36V48.3408Z",
    fill: "#EDEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7632_7878",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 48,
    width: 101,
    height: 75
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6855 48.3408H161.328V118.36C161.328 119.334 160.941 120.268 160.252 120.956C159.563 121.645 158.629 122.032 157.655 122.032H65.3579C64.3839 122.032 63.4498 121.645 62.7611 120.956C62.0724 120.268 61.6855 119.334 61.6855 118.36V48.3408Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7632_7878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6855 48.3408H157.328V118.36C157.328 119.334 156.941 120.268 156.252 120.956C155.563 121.645 154.629 122.032 153.655 122.032H61.3579C60.3839 122.032 59.4498 121.645 58.7611 120.956C58.0724 120.268 57.6855 119.334 57.6855 118.36V48.3408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.716 95H82.1626C80.9682 95 80 95.9682 80 97.1626C80 98.357 80.9682 99.3252 82.1626 99.3252H142.716C143.91 99.3252 144.879 98.357 144.879 97.1626C144.879 95.9682 143.91 95 142.716 95Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.376 102.688H90.1626C88.9682 102.688 88 103.657 88 104.851C88 106.045 88.9682 107.014 90.1626 107.014H134.376C135.571 107.014 136.539 106.045 136.539 104.851C136.539 103.657 135.571 102.688 134.376 102.688Z",
    fill: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.53 111H97.4703C96.6583 111 96 111.895 96 113C96 114.105 96.6583 115 97.4703 115H127.53C128.342 115 129 114.105 129 113C129 111.895 128.342 111 127.53 111Z",
    fill: "#E9E9EA"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5889 64H64V68.3669H73.5889V64Z",
    fill: "#E9E9EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.679 65.8613H76.6973V66.5046H118.679V65.8613Z",
    fill: "#E9E9EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5889 72.502H63V76.8689H72.5889V72.502Z",
    fill: "#E9E9EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.679 74.3643H75.6973V75.0075H117.679V74.3643Z",
    fill: "#E9E9EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "big-circle",
    d: "M137.225 74.226L145.52 61.4482C142.681 59.6093 139.31 58.7673 135.94 59.0551C132.57 59.3429 129.391 60.744 126.905 63.0376C124.419 65.3312 122.767 68.3869 122.209 71.7232C121.651 75.0594 122.219 78.4864 123.824 81.4641C125.428 84.4418 127.978 86.8009 131.071 88.1696C134.165 89.5383 137.625 89.8387 140.908 89.0236C144.191 88.2084 147.109 86.324 149.203 83.6674C151.297 81.0108 152.447 77.7329 152.472 74.3505C152.475 74.0708 152.451 73.7969 152.437 73.5211L137.225 74.226Z",
    fill: "#46CD80"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "small-circle",
    d: "M152.432 73.5227C152.322 71.1052 151.637 68.7488 150.434 66.649C149.231 64.5493 147.545 62.7669 145.514 61.4497L137.219 74.2275L152.432 73.5227Z",
    fill: "#6041B0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108 59.5H61H53L41 128H70.5L74.5 78.5H108C108 78.5 115.5 77 115.5 69C115.5 61 108 59.5 108 59.5Z",
    fill: "#E8E5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.082 42.2207H60.7055C58.6774 42.2207 57.0332 43.8649 57.0332 45.893V52.0135C57.0332 54.0417 58.6774 55.6859 60.7055 55.6859H161.082C163.11 55.6859 164.754 54.0417 164.754 52.0135V45.893C164.754 43.8649 163.11 42.2207 161.082 42.2207Z",
    fill: "#B0A0D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7876 59.1133C65.0355 59.1133 71.7217 52.4271 71.7217 44.1792C71.7217 35.9313 65.0355 29.2451 56.7876 29.2451C48.5397 29.2451 41.8535 35.9313 41.8535 44.1792C41.8535 52.4271 48.5397 59.1133 56.7876 59.1133Z",
    fill: "#ECAD29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7632_7878",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 29,
    width: 31,
    height: 31
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7876 59.1133C65.0355 59.1133 71.7217 52.4271 71.7217 44.1792C71.7217 35.9313 65.0355 29.2451 56.7876 29.2451C48.5397 29.2451 41.8535 35.9313 41.8535 44.1792C41.8535 52.4271 48.5397 59.1133 56.7876 59.1133Z",
    fill: "#FBBE3D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7632_7878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7876 59.1133C67.0355 59.1133 73.7217 52.4271 73.7217 44.1792C73.7217 35.9313 67.0355 29.2451 58.7876 29.2451C50.5397 29.2451 43.8535 35.9313 43.8535 44.1792C43.8535 52.4271 50.5397 59.1133 58.7876 59.1133Z",
    fill: "#FBBE3D"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2818 155.328V118.849L35.2441 108.812V80.1677C35.2441 80.1677 35.489 62.2957 55.5643 62.2957H105.018C105.018 62.2957 111.139 61.8061 111.628 68.6611C111.628 68.6611 111.383 75.2713 105.018 75.2713H71.7225L65.1123 155.328H45.2818Z",
    fill: "#D64378"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7632_7878",
    style: {
      masktype: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 62,
    width: 77,
    height: 94
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2818 155.328V118.849L35.2441 108.812V80.1677C35.2441 80.1677 35.489 62.2957 55.5643 62.2957H105.018C105.018 62.2957 111.139 61.8061 111.628 68.6611C111.628 68.6611 111.383 75.2713 105.018 75.2713H71.7225L65.1123 155.328H45.2818Z",
    fill: "#C83870"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7632_7878)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2818 155.328V118.849L39.2441 108.812V80.1677C39.2441 80.1677 39.489 62.2957 59.5643 62.2957H109.018C109.018 62.2957 115.139 61.8061 115.628 68.6611C115.628 68.6611 115.383 75.2713 109.018 75.2713H75.7225L69.1123 155.328H49.2818Z",
    fill: "#E55388"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7632_7878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 126.573,
    fill: "white",
    transform: "translate(35 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.88e9aab3c174d625c10c7de96b2674c9.svg";
export { ForwardRef as ReactComponent };